module.exports = __webpack_public_path__ + "img/02.90631738.png";